/* eslint-disable */
export default {
  to: 'Para:',
  enterNameOrPhoneNumber: 'Introduzir número',
} as const;

// @key: @#@"to"@#@ @source: @#@"To:"@#@
// @key: @#@"enterNameOrPhoneNumber"@#@ @source: @#@"Enter Number"@#@
